import { LuShieldCheck, LuInfo, LuCircleAlert } from "react-icons/lu";

// Shared presentational pieces for the identity-verification screens (SSN2 design).
// Colors mirror the SkinnyRx design tokens (brand plum / ink / status hues).

const IdentityChip = () => (
  <div className="mb-[22px] inline-flex items-center gap-[9px] rounded-full bg-[rgba(97,96,176,0.08)] px-[15px] py-2 text-[13px] font-medium text-[#40336e]">
    <LuShieldCheck size={17} />
    <span>Identity check</span>
  </div>
);

const IntroNote = () => (
  <div className="mb-[30px] flex items-start gap-2.5 rounded-xl bg-[#efedfa] px-4 py-3.5">
    <LuInfo size={15} className="mt-0.5 shrink-0 text-[#6160b0]" />
    <span className="text-[13.5px] leading-[1.5] text-[#303030]">
      Federal telehealth rules require us to confirm who you are before a
      clinician can issue a prescription.{" "}
      <strong className="font-semibold text-[#40336e]">
        We can’t move forward with your order until this step is complete
      </strong>{" "}
      — it takes just a moment.
    </span>
  </div>
);

const DEFAULT_ERROR_TITLE = "We couldn’t verify your identity";

const ErrorBanner = ({
  title = DEFAULT_ERROR_TITLE,
  message,
}: {
  title?: string;
  message: string;
}) => (
  <div className="mb-6 flex items-start gap-[11px] rounded-2xl border border-[#cd0707]/20 bg-[#fbe2e2] px-4 py-3.5">
    <LuCircleAlert size={20} className="mt-0.5 shrink-0 text-[#cd0707]" />
    <div>
      <div className="mb-[3px] text-sm font-semibold text-[#cd0707]">
        {title}
      </div>
      <div className="text-[13.5px] leading-[1.5] text-[#303030]">
        {message}
      </div>
    </div>
  </div>
);

// Inline reassurance line — exact reference (no box, no badges).
const EncryptedNote = () => (
  <div className="mt-5 flex items-start gap-[9px]">
    <LuShieldCheck size={17} className="mt-px shrink-0 text-[#078326]" />
    <span className="text-[13px] font-medium leading-[1.5] text-[#078326]">
      Encrypted in transit and used only to confirm your identity.
    </span>
  </div>
);

export { IdentityChip, IntroNote, ErrorBanner, EncryptedNote };
